import {useQuery} from 'react-query'
import {EditModalForm} from './EditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { getDealerById} from '../core/_requests'
//import { EditModalHeader } from './EditModalHeader'

const EditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: dealer,
    error,
  } = useQuery(
    `${QUERIES.DEALER_LIST}-dealer-${itemIdForUpdate}`,
    () => {
      return getDealerById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <EditModalForm isDealerLoading={isLoading} dealer={{id: undefined}} />
  }

  if (!isLoading && !error && dealer) {
    return <EditModalForm isDealerLoading={isLoading} dealer={dealer} />
  }

  return null
}

export {EditModalFormWrapper}
